import { getSessionStorage } from '../../../_common/client/session-storage';
import { sessionStorageKeyIsExpandedPrefix } from './constants';

export const writeExpansionStatusToStorage = (productId: string, isExpanded: boolean) => {
    const sessionStorage = getSessionStorage();
    sessionStorage.setItem(`${sessionStorageKeyIsExpandedPrefix}-${productId}`, `${isExpanded}`);
};
